import { MapPin, EnvelopeSimple, InstagramLogo, WhatsappLogo } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const WHATSAPP = "https://wa.me/5521987356892";
const INSTAGRAM = "https://instagram.com/piabetashoppingcenter";
const EMAIL = "admvmpiabeta@gmail.com";

export default function Footer() {
  return (
    <footer className="relative bg-vm-surface border-t border-vm-border pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 pb-16">
          <div>
            <h3 className="font-serif text-2xl mb-4">VM Piabetá</h3>
            <p className="text-sm text-vm-mutedFg leading-relaxed max-w-xs">
              Street mall com praticidade, negócios e conveniência em um só lugar. Piabetá, Magé — RJ.
            </p>
            <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-5 text-sm text-vm-mutedFg hover:text-vm-gold transition-colors" data-testid="footer-instagram">
              <InstagramLogo size={18} weight="duotone" /> @piabetashoppingcenter
            </a>
          </div>
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-vm-gold mb-5">Contato</p>
            <div className="space-y-4 text-sm text-vm-mutedFg">
              <div className="flex items-start gap-3">
                <MapPin size={20} weight="duotone" className="text-vm-gold shrink-0 mt-0.5" />
                <span data-testid="footer-address">Rua Eduardina de Miranda Telles, 250 — 1º e 2º Piso, Piabetá, Magé - RJ · CEP 25931-774</span>
              </div>
              <a href={`https://wa.me/5521987356892`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-vm-fg transition-colors" data-testid="footer-whatsapp">
                <WhatsappLogo size={20} weight="duotone" className="text-vm-gold" />
                (21) 98735-6892
              </a>
              <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 hover:text-vm-fg transition-colors" data-testid="footer-email">
                <EnvelopeSimple size={20} weight="duotone" className="text-vm-gold" />
                {EMAIL}
              </a>
            </div>
          </div>
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-vm-gold mb-5">Navegação</p>
            <div className="flex flex-col gap-3 text-sm text-vm-mutedFg">
              <Link to="/shopping" className="text-left hover:text-vm-fg transition-colors">O Shopping</Link>
              <Link to="/lojas" className="text-left hover:text-vm-fg transition-colors">Lojas & Espaços</Link>
              <Link to="/corporate" className="text-left hover:text-vm-fg transition-colors">VM Corporate</Link>
              <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="text-left hover:text-vm-fg transition-colors">Quero Alugar</a>
            </div>
            <div className="flex items-center gap-3 mt-6">
              <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-full border border-vm-border flex items-center justify-center text-vm-mutedFg hover:text-vm-gold hover:border-vm-gold/50 transition-colors" data-testid="social-instagram" aria-label="Instagram">
                <InstagramLogo size={18} weight="duotone" />
              </a>
              <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="h-10 w-10 rounded-full border border-vm-border flex items-center justify-center text-vm-mutedFg hover:text-vm-gold hover:border-vm-gold/50 transition-colors" data-testid="social-whatsapp" aria-label="WhatsApp">
                <WhatsappLogo size={18} weight="duotone" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-vm-border pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs text-vm-mutedFg text-center sm:text-left">
            <p>© {new Date().getFullYear()} VM Piabetá Shopping Center Ltda. Todos os direitos reservados.</p>
            <p className="mt-1 text-vm-mutedFg/70">CNPJ: 35.149.536/0001-58</p>
          </div>
          <a href="/admin/login" className="text-xs text-vm-mutedFg/60 hover:text-vm-gold transition-colors" data-testid="footer-admin-link">Área Administrativa</a>
        </div>
      </div>

      <div className="pointer-events-none select-none max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-serif text-[15vw] leading-none text-white/[0.03] -mb-6">VM PIABETÁ</p>
      </div>
    </footer>
  );
}
